module.exports = __webpack_public_path__ + "static/media/nelf.85ef08f1.png";